import {useTranslation} from "react-i18next";

const PricingTableCalculateButton = (
    {setIsCalculatorModalOpen}: {setIsCalculatorModalOpen: (arg0: boolean) => void}
) => {

    const {t} = useTranslation();

    return (
        <>
            <div className="opy-page-prices" onClick={() => setIsCalculatorModalOpen(true)}>
                <div className="opy-bg-light-blue pt-5">
                    <div className="container">
                        <button className="d-flex text-white ps-2 pe-3 py-2 opy-bg-green calculate-button">
                            <span className="me-2 question-icon">?</span>
                            <span>{t('commission_fee_calculator')}</span>
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PricingTableCalculateButton;
